module.exports = __webpack_public_path__ + "tickets-new.svg?e33ccb15c0fc739c2eadb1f78dc2bc65";